/**
 * Accordion Item — view.js
 *
 * Front-end behavior for the dynamic block. render.php outputs the panel
 * collapsed (aria-expanded="false", no state classes); CSS collapses it
 * via grid-template-rows: 0fr and animates open/close. This script only
 * toggles state — the `hidden` attribute is no longer used because
 * `hidden` (display: none) cannot animate.
 *
 * State toggled per click:
 *   - aria-expanded on the toggle button
 *   - `is-active` on the block wrapper (drives panel + icon CSS)
 *   - `active` on the icon-box
 */

const BLOCK_CLASS = "wp-block-prudential-blocks-prudential-accordion-item";

function initAccordionItem(block) {
	const toggle = block.querySelector(`.${BLOCK_CLASS}__toggle`);
	const panel = block.querySelector(`.${BLOCK_CLASS}__panel`);

	if (!toggle || !panel) {
		return;
	}

	const iconBox = toggle.querySelector(`.${BLOCK_CLASS}__icon-box`);

	toggle.addEventListener("click", () => {
		const isOpen = toggle.getAttribute("aria-expanded") === "true";
		const next = !isOpen;

		toggle.setAttribute("aria-expanded", String(next));
		block.classList.toggle("is-active", next);

		if (iconBox) {
			iconBox.classList.toggle("active", next);
		}
	});
}

function init() {
	document.querySelectorAll(`.${BLOCK_CLASS}`).forEach(initAccordionItem);
}

// viewScript is enqueued in the footer, so the DOM is normally ready, but
// guard for defer/async loading strategies just in case.
if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", init);
} else {
	init();
}
